"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrivacyPolicyContent = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const bridge_1 = require("@completeanatomy/bridge");
const i18n_1 = require("@completeanatomy/i18n");
const storage_1 = require("@completeanatomy/storage");
const ui_1 = require("@completeanatomy/ui");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const styled_components_1 = __importStar(require("styled-components"));
const router_1 = require("../../router");
const PrivacyAlert_1 = require("../PrivacyAlert/PrivacyAlert");
const PrivacySummary_1 = require("../PrivacySummary/PrivacySummary");
function PrivacyPolicyContent() {
    const navigate = (0, react_router_dom_1.useNavigate)();
    const [declined, toggleDeclined] = (0, ui_1.useToggleState)(false);
    const { t } = (0, i18n_1.useTranslation)();
    const bridge = (0, bridge_1.useBridge)();
    const storage = (0, storage_1.useStorageService)();
    (0, react_1.useEffect)(() => {
        storage === null || storage === void 0 ? void 0 : storage.put('isPrivacyPolicyAccepted', 'false');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const onDecline = () => {
        toggleDeclined();
        storage === null || storage === void 0 ? void 0 : storage.put('isPrivacyPolicyAccepted', 'false');
        bridge === null || bridge === void 0 ? void 0 : bridge.declinePrivacyPolicy();
    };
    const onClickAccept = () => {
        bridge === null || bridge === void 0 ? void 0 : bridge.acceptPrivacyPolicy();
        storage === null || storage === void 0 ? void 0 : storage.put('isPrivacyPolicyAccepted', 'true');
        storage === null || storage === void 0 ? void 0 : storage.put('pushNotificationsDeclined', 'true');
        navigate(`${router_1.Route.Base}/${router_1.Route.ProfileSurvey}`);
    };
    const PrivacyMainContent = () => {
        return ((0, jsx_runtime_1.jsxs)(ContentContainer, { "data-e2e": 'PrivacyPolicyContent_ContentContainer', children: [(0, jsx_runtime_1.jsx)(PrivacySummary_1.PrivacySummary, { "data-e2e": 'PrivacyPolicyContent_PrivacySummary' }), (0, jsx_runtime_1.jsxs)(Buttons, { "data-e2e": 'PrivacyPolicyContent_Buttons', children: [(0, jsx_runtime_1.jsx)(StyledSecondaryButton, { onClick: onDecline, "data-e2e": 'PrivacyPolicyContent_StyledSecondaryButton', children: t(i18n_1.Strings.common.decline) }), (0, jsx_runtime_1.jsx)(StyledPrimaryButton, { onClick: onClickAccept, "data-e2e": 'PrivacyPolicyContent_StyledPrimaryButton', children: t(i18n_1.Strings.common.accept) })] })] }));
    };
    return ((0, jsx_runtime_1.jsx)(Container, { "data-e2e": 'PrivacyPolicyContent_Container', children: declined ? (0, jsx_runtime_1.jsx)(PrivacyAlert_1.PrivacyAlert, { onBack: onDecline, "data-e2e": 'PrivacyPolicyContent_PrivacyAlert' }) : (0, jsx_runtime_1.jsx)(PrivacyMainContent, { "data-e2e": 'PrivacyPolicyContent_PrivacyMainContent' }) }));
}
exports.PrivacyPolicyContent = PrivacyPolicyContent;
exports.default = (0, storage_1.withStorageProvider)(PrivacyPolicyContent);
const Container = styled_components_1.default.div `
  position: relative;
  flex-flow: column nowrap;
  box-sizing: border-box;

  ${ui_1.device.all((0, styled_components_1.css) `
    justify-content: center;
  `)}

  width: 98%;
  height: 100%;
  padding: 0 24px;

  background-color: ${({ theme }) => theme.background};
`;
const ContentContainer = styled_components_1.default.div `
  justify-content: center;
  position: relative;
  display: flex;
  margin: 0 auto;
`;
const Buttons = styled_components_1.default.div `
  position: fixed;
  right: 32px;
  bottom: 0;
  left: 32px;

  display: flex;
  flex-flow: row wrap-reverse;
  align-items: center;
  justify-content: center;

  margin-top: 20px;

  height: 112px;
  background-image: linear-gradient(
    to top,
    ${({ theme }) => theme.background},
    rgba(17, 21, 28, 0.8) 15%,
    rgba(17, 21, 28, 0.4)
  );
  ${ui_1.devicePortrait.all((0, styled_components_1.css) `
    padding: 32px 0;
  `)}
`;
const StyledSecondaryButton = (0, styled_components_1.default)(ui_1.SecondaryButton) `
  background-color: transparent;
  color: ${({ theme }) => theme.userOnboarding.primaryButton.enabled.background};
  border: solid 1px
    ${({ theme }) => theme.userOnboarding.primaryButton.enabled.background};
  white-space: nowrap;
  text-transform: uppercase;

  border-radius: 4px;
  margin: 10px 30px;
  padding: 16px 0;

  ${ui_1.deviceLandscape.all((0, styled_components_1.css) `
    width: 30%;
  `)}

  ${ui_1.devicePortrait.all((0, styled_components_1.css) `
    width: 100%;
  `)}

  ${ui_1.device.laptop((0, styled_components_1.css) `
    width: 18%;
  `)}
`;
const StyledPrimaryButton = (0, styled_components_1.default)(ui_1.PrimaryButton) `
  white-space: nowrap;
  text-transform: uppercase;
  background-color: ${({ theme }) => theme.userOnboarding.primaryButton.enabled.background};
  color: ${({ theme }) => theme.userOnboarding.primaryButton.enabled.text};

  border-radius: 4px;
  margin: 10px 30px;
  padding: 16px 0;

  ${ui_1.deviceLandscape.all((0, styled_components_1.css) `
    width: 30%;
  `)}

  ${ui_1.devicePortrait.all((0, styled_components_1.css) `
    width: 100%;
  `)}

  ${ui_1.device.laptop((0, styled_components_1.css) `
    width: 18%;
  `)}
`;
